// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","396":"0d84f9af","455":"75c28abb","977":"ea22d1e1"}[chunkId] + ".chunk.js";
};